import React from 'react';
import { SimpleGrid, Cell } from '../layout-grid/Grid'
import { NavLink } from 'react-router-dom';
import { getSetting } from 'launchpad';
import Fade from 'react-move-stuff';
import { Snip, Image, DynamicMenu, helpers } from 'launchpad';

class Footer extends React.Component {

  socialLink = (type, title, icon) => {
    icon = icon || type
    title = title || helpers.getTitle(type)
    return getSetting(type) ? <div key={type} className='social-link'>
      <a href={getSetting(type)} className={type + ' social-button-link'} target="_blank">
        <span className={`fa fa-${icon}`} /> {title}
      </a>
    </div> : ''
  }
  render() {
    const socialLinks = {
      facebook: '',
      twitter: '',
      linkedin: 'LinkedIn',
      instagram: '',
      youtube: 'YouTube',
      pinterest: ''
    }
    return (
      <footer>
        {/* <Fade>
          <Image name='footer-bg' page='footer' useEditIcon>
            <div className='container'>
              <div className='pre-footer'>
                <Snip name='pre-footer' />
                <NavLink to='about' className='btn btn-inverted'>Learn more</NavLink>
              </div>
            </div>
          </Image>
        </Fade> */}

        <div>
          <div className='footer-lists'>
            <div className='row'>
              <div className='col-lg-4 logo'>
                <Image name='foter-logo' mode='contain' dimmer={false} />
              </div>
              <div className='col-lg-8'>
                <div className='row footer-links'>

                  <div className='col-lg-3 col-md-6'>
                    <h3>About Frame USA</h3>
                    <DynamicMenu disableSubmenu layout='vertical' menuId='footer-about' />
                  </div>

                  <div className='col-lg-3 col-md-6'>
                    <h3>Company</h3>
                    <DynamicMenu disableSubmenu layout='vertical' menuId='footer-company' />
                  </div>

                  <div className='col-lg-3 col-md-6'>
                    <h3>Shop</h3>
                    <DynamicMenu disableSubmenu layout='vertical' menuId='footer-shop' />
                  </div>

                  <div className='col-lg-3 social col-md-6'>
                    <h3>Social</h3>
                    {Object.keys(socialLinks).map(key => this.socialLink(key, socialLinks[key]))}
                  </div>

                </div>
              </div>
            </div>
            <div className='copyright'>
                all rights reserved &copy; Frame USA {(new Date()).getFullYear()}
            </div>

            {/* <ul>
                <li>CODEPILOT</li>
                <li><NavLink to='/'>Home</NavLink></li>
                <li><NavLink to='/'>Portfolio</NavLink></li>
                <li><NavLink to='/'>Login</NavLink></li>
              </ul>

              <ul>
                <li>WHY CODEPILOT?</li>
                <li><NavLink to='/'>Overview</NavLink></li>
                <li><NavLink to='/'>Experience</NavLink></li>
                <li><NavLink to='/'>Estimates & billing</NavLink></li>
              </ul>

              <ul>
                <li>SUPPORT</li>
                <li><NavLink to='/'>Login</NavLink></li>
                <li><NavLink to='/'>New support ticket</NavLink></li>
                <li><NavLink to='/'>Existing support ticket</NavLink></li>
              </ul>

              <div className='contact'>
                <div> <b>Call:</b> <a href={'tel:' + getSetting('phone')}>{getSetting('phone')}</a></div>
                <div> <b>Email:</b> <a href={'mailto:' + getSetting('email')}>{getSetting('email')}</a></div>
                <div className='social'>
                  {getSetting('facebook') ? <a href={getSetting('facebook')} className='fa fa-facebook' target="_blank" /> : ''}
                  {getSetting('twitter') ? <a href={getSetting('twitter')} className='fa fa-twitter' target="_blank" /> : ''}
                  {getSetting('instagram') ? <a href={getSetting('instagram')} className='fa fa-instagram' target="_blank" /> : ''}
                  {getSetting('youtube') ? <a href={getSetting('youtube')} className='fa fa-youtube-play' target="_blank" /> : ''}
                  {getSetting('pinterest') ? <a href={getSetting('pinterest')} className='fa fa-pinterest' target="_blank" /> : ''}
                </div>
              </div> */}

          </div>
        </div>

        {/* <div className='sub-footer container'>
            &copy; Frame USA {(new Date()).getFullYear()}
        </div> */}

        {/* <div className='container'>
          <div className='row'>
            <div className='col m8 contact'>
              <div className='row'>
                <span className='col m4'><NavLink to='/consultation'>Schedule a Consultation</NavLink></span>

              </div>
              <div className='row'>
                <div className='col s12'>
                  <div className='sub-contact'>
                    &copy; {(new Date()).getFullYear()} Silicon Valley Developers |
                    <NavLink to='/terms-of-use'>Terms of Use</NavLink>
                    <NavLink to='/disclaimer'>Disclaimer</NavLink>
                    {getSetting('address')}
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div> */}
      </footer>
    );
  }
}
export default Footer;
